import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AppControllerService } from "../../../app-controller.service";
import { ModuleConfig } from "../../models/module-config.model";
import { ModulePrefix } from "../../models/module-prefix.model";
let ModuleConfigService = class ModuleConfigService {
    appControllerService;
    _moduleConfigNameLookup;
    currentModulePrefix = null;
    constructor(appControllerService) {
        this.appControllerService = appControllerService;
        this._moduleConfigNameLookup = new Map();
    }
    addModuleConfigName(moduleID, configName) {
        this._moduleConfigNameLookup.set(moduleID, configName);
    }
    removeModuleConfigName(moduleID) {
        return this._moduleConfigNameLookup.delete(moduleID);
    }
    getModuleConfigName(moduleID) {
        if (!moduleID) {
            throw new Error("Module ID not defined");
        }
        if (this._moduleConfigNameLookup.size <= 0) {
            throw new Error("Module config lookup empty");
        }
        return this._moduleConfigNameLookup.get(moduleID);
    }
    getCurrentlySelectedModuleConfigName() {
        if (!this.appControllerService.selectedModuleID) {
            throw new Error("Currently selected module ID not defined");
        }
        const configName = this.getModuleConfigName(+this.appControllerService.selectedModuleID);
        if (configName) {
            this.setModulePrefixFromModuleConfigName(configName);
        }
        return configName;
    }
    getModuleMapValidatorSettings(moduleItems) {
        const currentModulePrefix = this.getCurrentlySelectedModuleSystemPrefix();
        if (!currentModulePrefix) {
            return null;
        }
        return moduleItems[currentModulePrefix]?.mapServiceValidator ?? null;
    }
    checkModuleName(name) {
        const currentSelectedModuleConfigName = this.getCurrentlySelectedModuleConfigName();
        if (currentSelectedModuleConfigName === name) {
            this.setModulePrefixFromModuleConfigName(currentSelectedModuleConfigName);
            return true;
        }
        else {
            return false;
        }
    }
    isPropertyValuationModule() {
        return this.checkModuleName(ModuleConfig.PropertyValuation);
    }
    isTownPlanningModule() {
        return this.checkModuleName(ModuleConfig.TownPlanning);
    }
    isGautrainModule() {
        return this.checkModuleName(ModuleConfig.Gautrain);
    }
    isBuildingPlanModule() {
        return this.checkModuleName(ModuleConfig.BuildingPlans);
    }
    isCemeteryModule() {
        return this.checkModuleName(ModuleConfig.Cemetery);
    }
    isWayleaveModule() {
        return this.checkModuleName(ModuleConfig.Wayleaves);
    }
    isPropertyAndLeaseModule() {
        return this.checkModuleName(ModuleConfig.PropertyAndLease);
    }
    isEnvironmentalHealthModule() {
        return this.checkModuleName(ModuleConfig.EnvironmentalHealth);
    }
    isDemolitionManagementModule() {
        return this.checkModuleName(ModuleConfig.DemolitionManagement);
    }
    isZoningCertificateModule() {
        return this.checkModuleName(ModuleConfig.ZoningCertificate);
    }
    isTrainingModule() {
        return this.checkModuleName(ModuleConfig.TrainingModule);
    }
    isInformalTradeModule() {
        return this.checkModuleName(ModuleConfig.InformalTrade);
    }
    isRatesCertificateModule() {
        return this.checkModuleName(ModuleConfig.RatesCertificate);
    }
    isBusinessLicenceModule() {
        return this.checkModuleName(ModuleConfig.BusinessLicence);
    }
    isElectricalConnectionModule() {
        return this.checkModuleName(ModuleConfig.ElectricalConnection);
    }
    isStreetNamingModule() {
        return this.checkModuleName(ModuleConfig.StreetNaming);
    }
    isMondiModule() {
        return this.checkModuleName(ModuleConfig.Mondi);
    }
    setModulePrefixFromModuleConfigName(currentSelectedModuleConfigName) {
        switch (currentSelectedModuleConfigName) {
            case ModuleConfig.TownPlanning:
                this.currentModulePrefix = ModulePrefix.TownPlanning;
                break;
            case ModuleConfig.Gautrain:
                this.currentModulePrefix = ModulePrefix.Gautrain;
                break;
            case ModuleConfig.BuildingPlans:
                this.currentModulePrefix = ModulePrefix.BuildingPlans;
                break;
            case ModuleConfig.BuildingPlansInspectorate:
                this.currentModulePrefix = ModulePrefix.BuildingPlansInspectorate;
                break;
            case ModuleConfig.Wayleaves:
                this.currentModulePrefix = ModulePrefix.Wayleaves;
                break;
            case ModuleConfig.PropertyAndLease:
                this.currentModulePrefix = ModulePrefix.PropertyAndLease;
                break;
            case ModuleConfig.Cemetery:
                this.currentModulePrefix = ModulePrefix.Cemetery;
                break;
            case ModuleConfig.PropertyValuation:
                this.currentModulePrefix = ModulePrefix.PropertyValuation;
                break;
            case ModuleConfig.Advertising:
                this.currentModulePrefix = ModulePrefix.Advertising;
                break;
            case ModuleConfig.EnvironmentalHealth:
                this.currentModulePrefix = ModulePrefix.EnvironmentalHealth;
                break;
            case ModuleConfig.DemolitionManagement:
                this.currentModulePrefix = ModulePrefix.DemolitionManagement;
                break;
            case ModuleConfig.ZoningCertificate:
                this.currentModulePrefix = ModulePrefix.ZoningCertificate;
                break;
            case ModuleConfig.TrainingModule:
                this.currentModulePrefix = ModulePrefix.TrainingModule;
                break;
            case ModuleConfig.InformalTrade:
                this.currentModulePrefix = ModulePrefix.InformalTrade;
                break;
            case ModuleConfig.RatesCertificate:
                this.currentModulePrefix = ModulePrefix.RatesCertificate;
                break;
            case ModuleConfig.BusinessLicence:
                this.currentModulePrefix = ModulePrefix.BusinessLicence;
                break;
            case ModuleConfig.ElectricalConnection:
                this.currentModulePrefix = ModulePrefix.ElectricalConnection;
                break;
            case ModuleConfig.StreetNaming:
                this.currentModulePrefix = ModulePrefix.StreetNaming;
                break;
            case ModuleConfig.Mondi:
                this.currentModulePrefix = ModulePrefix.Mondi;
                break;
            default:
                this.currentModulePrefix = null;
                break;
        }
    }
    getCurrentlySelectedModuleSystemPrefix() {
        return this.currentModulePrefix;
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
};
ModuleConfigService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ModuleConfigService);
export { ModuleConfigService };
